import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-200/50 border-t border-background-300/40">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-drop-fill text-background-50 text-base"></i>
              </div>
              <span className="text-lg font-semibold" style={{ fontFamily: 'var(--font-heading)' }}>
                奶水乐园
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专为哺乳期妈妈打造的母乳喂养知识平台，涵盖催奶食谱、追奶技巧、奶水不足解决方案、母乳储存及新生儿喂养指南。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3">热门分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line text-base"></i>
                hello@naishuileyuan.com
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-phone-line text-base"></i>
                400-888-6688
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-map-pin-line text-base"></i>
                北京市朝阳区建国路88号
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 奶水乐园 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            本网站内容仅供参考，不能替代专业医疗建议
          </p>
        </div>
      </div>
    </footer>
  );
}